import { app } from '../app.js';

export default {
    computed: {
        cart() {
            return app.cart;
        }
    },
    data() {
        return {
         cartItems: [],
         isShowCheckoutButton: false
        }
    },

    mounted(){
        setTimeout(() => {
            this.checkForReservedProduct();
        }, 500);
    },
    
    watch: { // Debounce and watchers - https://vuejs.org/v2/guide/computed.html#Watchers
        cart() {
           this.checkForReservedProduct();
        }
    },

    methods: {
        updateQuantity(...args) {
            app.updateQuantity(...args);

        },
        checkForReservedProduct() {
        

           try {
                console.log('ca', this.cart);
                const obj = this.cart;
                let dataObj;
                Object.keys(obj).forEach(function(key) {
                 dataObj =  obj['items'];
                 });
                 let cartProp = [];
              for (let key in dataObj) {
                  let prop =  dataObj[key];
                  cartProp.push(prop.properties)
              }
              this.cartItems = cartProp;
          } catch (error) {
            console.log(error.response, 'Error in requesting sample')
          
          } finally {
          
            this.isCheckoutHidden();
          }

       },

       isCheckoutHidden(){
           let isReserved = this.cartItems;


           if(isReserved.every(element => element == null)){
               this.isShowCheckoutButton =  true;
               return true;
           } else if (isReserved.every(element => element != null)){
            this.isShowCheckoutButton =  true;
            return false;
           } else {
            this.isShowCheckoutButton =  false;
                return false;
       
           }
       }
    }
}